<template>
  <div class="row justify-center q-mt-sm">
    <q-spinner color="primary" size="4em" />
  </div>
</template>
